module.exports = __webpack_public_path__ + "img/UG.ccaa7a85.svg";